import "../css/catalogue.css";

const getWishlist = () =>
  JSON.parse(localStorage.getItem("nanzora_wishlist") ?? "[]");
const saveWishlist = (items) => {
  localStorage.setItem("nanzora_wishlist", JSON.stringify(items));
  window.dispatchEvent(new CustomEvent("nanzora:wishlist-updated"));
};

const identifyProduct = (card) => {
  const id =
    card.className.match(/post-(\d+)/)?.[1] ??
    card.querySelector("[data-product_id]")?.dataset.product_id;
  const link = card.querySelector("a[href*='/product/']");
  return {
    id: String(id ?? link?.href ?? ""),
    url: link?.href ?? "",
    name:
      card
        .querySelector(".wp-block-post-title, .wc-block-grid__product-title")
        ?.textContent.trim() ?? "Product",
  };
};

const enhanceCards = () => {
  const wishlist = getWishlist();
  document.querySelectorAll(".wc-block-product, .product").forEach((card) => {
    if (card.querySelector(".nanzora-wishlist-button")) return;
    const product = identifyProduct(card);
    if (!product.id) return;
    const button = document.createElement("button");
    button.type = "button";
    button.className = "nanzora-wishlist-button";
    button.setAttribute("aria-label", `Save ${product.name} to wishlist`);
    button.setAttribute(
      "aria-pressed",
      String(wishlist.some((item) => item.id === product.id)),
    );
    button.innerHTML = '<i class="ph ph-heart" aria-hidden="true"></i>';
    button.addEventListener("click", () => {
      const items = getWishlist();
      const index = items.findIndex((item) => item.id === product.id);
      if (index >= 0) items.splice(index, 1);
      else items.push(product);
      saveWishlist(items);
      button.setAttribute("aria-pressed", String(index < 0));
      window.nanzoraEmit?.(
        index < 0 ? "add_to_wishlist" : "remove_from_wishlist",
        { productId: product.id },
      );
    });
    card.append(button);
  });
};

enhanceCards();
new MutationObserver(enhanceCards).observe(document.body, {
  childList: true,
  subtree: true,
});

const trigger = document.querySelector("[data-nanzora-filter-trigger]");
const panel = document.querySelector("[data-nanzora-filter-panel]");

const overlayIsOpen = () =>
  Boolean(
    document.querySelector(".wc-block-product-filters.is-overlay-opened"),
  );

const syncFilterExpanded = () => {
  const open =
    overlayIsOpen() || (panel?.classList.contains("is-open") ?? false);
  trigger?.setAttribute("aria-expanded", String(open));
};

trigger?.addEventListener("click", () => {
  const overlayButton = document.querySelector(
    ".wc-block-product-filters__open-overlay",
  );
  if (overlayButton instanceof HTMLElement) {
    overlayButton.click();
    window.setTimeout(syncFilterExpanded, 0);
    return;
  }

  panel?.classList.toggle("is-open");
  syncFilterExpanded();
});

new MutationObserver(syncFilterExpanded).observe(document.body, {
  attributeFilter: ["class"],
  attributes: true,
  subtree: true,
});
